import { IsNRIC } from "common/validators";
import { HTTP_VERBS } from "../../enums";
import { AcpSharedDocumentDto } from "../domainObjects";

export const httpVerb = HTTP_VERBS.POST;
export const url = "/api/v1/users/retrieve-shared-acp-from-acp-it/";

export class Body {
	@IsNRIC()
	public trustedPersonUinfin!: string;
}

export class Response extends AcpSharedDocumentDto {}
